import 'reactjs-popup/dist/index.css';

import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { PopupProps } from 'reactjs-popup/dist/types';

import Button from '../Button/Button';
import { ArrowLeftIcon, UpArrowIcon } from '../Icon/Icon';
import {
  CloseButtonStyled,
  ContentSectionStyled,
  ControlsWrapperStyled,
  PopupStyled,
  TopButtonStyled,
} from './Popup.styled';

type PopupPropsT = {
  isOpen: boolean;
  isCloseButton?: boolean;
  isBackButton?: boolean;
  isModal?: boolean;
  isTopButton?: boolean;
  children: React.ReactNode;
  onClickBack?: () => void;
} & PopupProps;

const Popup: React.FC<PopupPropsT> = ({
  children,
  isOpen,
  onOpen,
  onClose,
  onClickBack,
  isModal = true,
  isCloseButton = true,
  isTopButton = false,
  isBackButton,
  ...props
}) => {
  const scrollToRef = useRef<HTMLDivElement>(null);

  const handleOpen = () => {
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <PopupStyled
      lockScroll
      open={isOpen}
      onClose={handleClose}
      onOpen={handleOpen}
      modal={isModal}
      {...props}
    >
      <ControlsWrapperStyled>
        {isBackButton && (
          <Button
            modifier="inline"
            onClick={onClickBack}
            isUpperCase={false}
            icon={<ArrowLeftIcon />}
          >
            <FormattedMessage id="common.back" defaultMessage="Back" />
          </Button>
        )}
        {isCloseButton && <CloseButtonStyled onClick={handleClose} />}
      </ControlsWrapperStyled>

      <ContentSectionStyled ref={scrollToRef}>
        {children}

        {isTopButton && (
          <TopButtonStyled
            modifier="inline"
            onClick={() => {
              scrollToRef.current?.scrollTo({ behavior: 'smooth', top: 0 });
            }}
          >
            <UpArrowIcon width="25px" />
            <FormattedMessage id="common.top" defaultMessage="Top" />
          </TopButtonStyled>
        )}
      </ContentSectionStyled>
    </PopupStyled>
  );
};

export default Popup;
